import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fdeacaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_2 = ["xlink:href"]

import { computed } from 'vue'
import { isNumber } from '~/util'

interface Props {
  name?: string
  size?: string | number
  color?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'icon',
  props: {
    name: null,
    size: null,
    color: null
  },
  setup(__props: any) {

const props = __props as {
  name?: string
  size?: string | number
  color?: string
}


const name = computed(() => '#' + props.name)
const style = computed(() => {
  return {
    fontSize: isNumber(props.size) ? props.size + 'px' : props.size,
    color: props.color
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: "u-icon",
    style: _normalizeStyle(_unref(style))
  }, [
    (_ctx.$slots.default)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("svg", _hoisted_1, [
          _createElementVNode("use", { "xlink:href": _unref(name) }, null, 8, _hoisted_2)
        ]))
  ], 4))
}
}

})